import { api } from './client';
import { endpoints } from './endpoints';

/**
 * Reporting content, from the reporter's side.
 *
 * Filing a report changes nothing about the thing reported -- it does not
 * unpublish a listing or flag an account. It puts the claim in front of a
 * moderator, and the decision is theirs. Deciding reports lives in
 * `admin.api.js`.
 *
 * `targetType` is 'INTERNSHIP', 'COMPANY' or 'STUDENT'.
 */
/** Whether the signed-in user already has an open report of this item. */
export function getMyReport({ targetType, targetId }) {
  return api.get(endpoints.reports.mine, {
    params: { target_type: targetType, target_id: targetId },
  });
}

export function reportContent({ targetType, targetId, reason }) {
  return api.post(endpoints.reports.root, {
    target_type: targetType,
    target_id: targetId,
    reason,
  });
}
